import axios from "axios";
import qs from "qs";
import Vue from "./../main";

let config = {
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    baseURL: "",
    // 请求超时时间
    timeout: 100000,
    // 每次请求携带cookie
    withCredentials: true,
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: 'json'
};

const instance = axios.create(config);

// http request 拦截器
instance.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token');
        if (!token && Vue.$cookies.get("token")) {
            token = Vue.$cookies.get("token");
        }
        if (token) { //判断token是否存在
            config.headers['TOKEN'] = token;  //将token设置成请求头
        }
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 自定义接口函数
instance.api = {
    // 公用请求接口
    request: function (options, callback) {
        instance.request({
            url: process.env.VUE_APP_URL + options.url,
            method: options.method,
            params:options.data || {},
        }).then((res) => {
            // 成功返回数据
            if(res.status == 200){
                callback(res.data);
            }else{
                console.log('api请求失败:', res);
            }
        }).catch((err) => {
            console.log('api请求fail:', err);
        })
    },
    // 登出
    logout: function (params, callback) {
        instance.post("/api/user/logout", params).then((res) => {
            Vue.$store.commit('userLogout', {});
            localStorage.setItem('token', null);
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    //阿里云直传参数
    aliossParams: function (params, callback) {
        instance.post("/api/qtclub/alioss/params", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 更新用户信息
    updateUserInfo: function (params, callback) {
        instance.post("/api/qtclub/user/updateInfo", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 用户信息
    getUserInfo: function (params, callback) {
        instance.get("/api/qtclub/user/getUserInfo", params).then((res) => {
            if (res.data.code != 200) {
                Vue.$store.commit('userLogout', {});
                // localStorage.setItem('token', null);
            }
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 用户是否VIP
    getUserIsVip: function (params, callback) {
        instance.get("/api/qtclub/user/getUserIsVip", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 首页banner
    getBanner: function (params, callback) {
        instance.get("/api/qtclub/index/getBanner?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 采风列表
    caifengList: function (params, callback) {
        instance.get("/api/qtclub/caifeng/getList?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 采风详情
    caifengDetail: function (params, callback) {
        instance.get("/api/qtclub/caifeng/getDetail?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库列表
    galleryList: function (params, callback) {
        instance.get("/api/qtclub/proxymatch/indexWeb?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库删除
    galleryDel: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/delImage", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库详情
    galleryDetail: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/imageDetail", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库新增
    galleryCreate: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/imageCreate", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库新增单图
    gallerySingCreateBatch: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/imageSingCreateBatch", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库更新
    galleryUpdate: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/imageUpdate", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 图库更新标题
    galleryUpdateTitle: function (params, callback) {
        instance.post("/api/qtclub/proxymatch/imageUpdateTitle", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 课程列表
    eduCourseList: function (params, callback) {
        instance.get("/api/qtclub/edu/index?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 课程详情
    eduCourseInfo: function (params, callback) {
        instance.get("/api/qtclub/edu/info?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 课程观看记录
    eduWatchRecords: function (params, callback) {
        instance.post("/api/qtclub/edu/watch_records", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 人工精修列表
    psList: function (params, callback) {
        instance.get("/api/qtclub/ps/getList?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 修图订单确认验收
    myPsConfirm: function (params, callback) {
        instance.get("/api/qtclub/userps/myPsConfirm?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 修图确认
    myPsCheck: function (params, callback) {
        instance.get("/api/qtclub/userps/myPsCheck?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 我的修图包
    userPsList: function (params, callback) {
        instance.get("/api/qtclub/userps/userPsList?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 我的修图包（个人中心）
    myPsList: function (params, callback) {
        instance.get("/api/qtclub/userps/myPsList?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 我的修图订单
    myPsOrderList: function (params, callback) {
        instance.get("/api/qtclub/userps/myPsOrderList?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // 创建修图订单
    createPsOrder: function (params, callback) {
        instance.post("/api/qtclub/userps/createPsOrder", params).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
    // AI命名
    aiName: function (params, callback) {
        instance.get("/api/qtclub/proxymatch/ai_name?" + qs.stringify(params)).then((res) => {
            callback(res.data);
        }).catch((error) => {
            callback({"code": 0});
        });
    },
}

export default instance